import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: inline-block;
  justify-content: center;
  text-align: center;
`;